import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

import { NeuButton } from '@neutron/react';

import { clearUser, setSessionId } from '../../redux/actions';

import {
  BackgroundImage,
  ErrorContainer,
  H1,
  H4,
  StyledDiv,
  Text
} from './ErrorPages.styles';
import ErrorPageImg from '../../assets/images/ErrorPageImg.png';

const ErrorPage403 = () => {
  const { removeUser, signinRedirect, signoutSilent } = useAuth();

  const dispatch = useDispatch();
  // appInsights.trackEvent({
  //   name: 'Login_Failure'
  // });
  const navigate = useNavigate();

  const gotoLogin = () => {
    window.localStorage.removeItem('authToken');
    window.localStorage.removeItem('orbitLastPath');
    window.localStorage.removeItem('34');
    sessionStorage.removeItem('sessionId');
    dispatch(setSessionId(''));
    dispatch(clearUser());
    removeUser();
    signoutSilent();
    if (process.env.REACT_APP_ENV === 'production') {
      console.log('Authorizing user...');
      signinRedirect();
    } else {
      navigate('/login');
    }
  };

  return (
    <StyledDiv>
      <BackgroundImage src={ErrorPageImg} alt="error page" />
      <ErrorContainer>
        <H1>403</H1>
        <H4>Access Denied</H4>
        <Text>Please contact your manager for access.</Text>
        <NeuButton color="blue" kind="primary" size="small" onClick={gotoLogin}>
          Back to Login
        </NeuButton>
      </ErrorContainer>
    </StyledDiv>
  );
};

export default ErrorPage403;
